module.exports = __webpack_public_path__ + "static/media/EastHampton_10.2aa444a1.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_10.JPG
// module id = 229
// module chunks = 0